// extracted by mini-css-extract-plugin
export default {"root":"Card-root-8f4fdb4b1951acb8d53e779d1ea64724"};